// extracted by mini-css-extract-plugin
module.exports = {"payment":"BonusTableData__payment--11v8a","paymentClm":"BonusTableData__paymentClm--3TXVo","def":"BonusTableData__def---1BU0","remarks":"BonusTableData__remarks--2yDuI"};